import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../utils/api';

const PermissionsContext = createContext({
    permissions: [],
    hasPermission: () => false,
    loading: true,
    refreshPermissions: () => { },
});

export const PermissionsProvider = ({ user, children }) => {
    const [permissions, setPermissions] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchPermissions = useCallback(async () => {
        if (!user) {
            setPermissions([]);
            setLoading(false);
            return;
        }

        try {
            const response = await api.get('/my-permissions');
            setPermissions(response.data?.permissions || []);
        } catch (error) {
            console.error('Failed to load permissions:', error);
            // Fall back to empty — super_admin still bypasses checks
            setPermissions([]);
        } finally {
            setLoading(false);
        }
    }, [user]);

    useEffect(() => {
        fetchPermissions();
    }, [fetchPermissions]);

    const hasPermission = useCallback((permissionKey) => {
        // Super admins have all permissions
        if (user?.role === 'super_admin') return true;
        return permissions.includes(permissionKey);
    }, [permissions, user]);

    return (
        <PermissionsContext.Provider value={{
            permissions,
            hasPermission,
            loading,
            refreshPermissions: fetchPermissions,
        }}>
            {children}
        </PermissionsContext.Provider>
    );
};

export const usePermissions = () => useContext(PermissionsContext);

export default PermissionsContext;
